function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteRow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.276,2.958C26.276,2.074 25.56,1.358 24.676,1.358L3.324,1.358C2.44,1.358 1.724,2.074 1.724,2.958L1.724,3.371C1.724,4.255 2.44,4.971 3.324,4.971L24.676,4.971C25.56,4.971 26.276,4.255 26.276,3.371C26.276,3.234 26.276,3.095 26.276,2.958Z",
    style: {
      fill: "#fff"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteRow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-row.56890f2002658d9b0f84fe2d8576bd8c.svg";